module.exports = __webpack_public_path__ + "static/img/6299_phase_function_Paper_PointsHejduk_Prediction.506c7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6299_phase_function_Paper_PointsHejduk_Prediction.png
// module id = G9pI
// module chunks = 0